import React, { useEffect, useState, useRef, useContext } from "react";
import { Helmet } from "react-helmet";
import { Domain, OrgIdContext } from "../../store/orgId_context";

const DDDHelmet = ({title}) => {
    const {domain} = useContext(OrgIdContext)
    return(<>
        <Helmet>
            <title>{title} | 
            {(domain === Domain.DDDInvoices && "DDD Invoices") || ""}
            {(domain === Domain.EInvoices && "E-Invoices") || ""}
            </title>
        </Helmet>
        </>)
};
export default DDDHelmet;